import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Home } from './Home';
import { Bio } from './Bio';
import { Discography } from './Discography';
import { Gallery } from './Gallery';
import { News } from './News';
import { Contact } from './Contact';
import { Footer } from './Footer';

function BasicExample() {
  const [showNavbar, setShowNavbar] = useState(true);
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setShowNavbar(window.innerWidth > 992); // 992 is Bootstrap's lg breakpoint
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleNavbar = () => {
    setIsNavbarCollapsed(!isNavbarCollapsed);
  };

  return (
    <Router>
      <Navbar expand="lg" className={`bg-body-light ${showNavbar ? 'd-lg-block' : 'd-lg-none'}`}>
        <Container>
          {showNavbar && (
            <Navbar.Brand>
              <img style={{ height: '65px', opacity: '0.8' }} src="./img/logo-cutout.png" alt="Logo" />
            </Navbar.Brand>
          )}
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleNavbar} className="custom-toggler">
            {isNavbarCollapsed ? (
              <div className="hamburger-icon">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            ) : (
              <span className="close-icon">X</span>
            )}
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav" in={!isNavbarCollapsed}>
            <Nav style={{ fontFamily: "Prata, Serif", fontSize: 'large', fontWeight: 'normal' }} className="me-auto">
              <Nav.Link as={Link} to="/#home">Home</Nav.Link>
              <Nav.Link as={Link} to="/bio">Bio</Nav.Link>
              <Nav.Link as={Link} to="/gallery">Gallery</Nav.Link>
              <Nav.Link as={Link} to="/discography">Discography</Nav.Link>
              <Nav.Link as={Link} to="/news">News</Nav.Link>
              <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/bio' element={<Bio />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/discography' element={<Discography />} />
          <Route path='/news' element={<News />} />
          <Route path='/contact' element={<Contact />} />
          {/* Add routes for other pages */}
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default BasicExample;

